module.exports = __webpack_public_path__ + "static/img/unconscious-bias-grad-recruitment.1eb8dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/unconscious-bias-grad-recruitment.png
// module id = 6Svl
// module chunks = 0